<template>
  <div class="panel-display-container">
    <div v-for="(shipmentTruck, tIndex) in shipmentTrucks" :key="tIndex" class="group">
      <h4>{{ $t('truck').capitalize() }} {{ tIndex + 1 }}</h4>
      <div style="display: flex; flex-wrap: wrap;">
        <div v-for="(group, gIndex) in shipmentTruck" :key="gIndex" style="margin: 5px;">
          <p>{{ $t('group').capitalize() }} {{ gIndex + 1 }}</p>
          <div style="display: flex; flex-wrap: wrap;">
            <div v-for="(panel, pIndex) in group.panels" :key="'group-' + gIndex + '-panel-' + pIndex"
              style="margin: 5px;"
              :style="{ width: panel.width / 2 + 'px', height: panel.length / 2 + 'px', backgroundColor: isFullPanel(panel) ? '#C79467' : '#70451F' }">
              <v-tooltip top>
                <template v-slot:activator="{ props }">
                  <div v-bind="props" :style="{ width: panel.width / 2 + 'px', height: panel.length / 2 + 'px' }">
                  </div>
                </template>
                <p><strong>{{ $t('components.panelConfiguration.wallPanelType') }}:</strong> {{ panel.id }}</p>
                <p class="panel-info-text"><strong>{{ $t('size').capitalize() }}:</strong> {{ panel.width }} x {{ panel.length }}</p>
              </v-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>


defineProps({
  shipmentTrucks: Array,
  isFullPanel: Function
});
</script>

<style scoped>
@import '@/assets/styles/components/panelCountEstimator/PanelizationPropositionPanelDisplay.css';
@import '@/assets/styles/components/panelCountEstimator/PanelizationPropositionList.css';
</style>